import _ from 'lodash';
import { AxiosServiceClass } from '@/classes/axiosService.class';
import { momentProvider } from '@/services/clock.service';
import { FrameworkService } from '@/services/framework.service';
import { StateService } from '@/services/state.service';
import { Helpers } from '@/common/helpers';

// This documentation added for reference.  Will be deleted eventually
// return $resource(EdgeApiConfig.path('scheduling/events/:eventId'), {
// 	eventId: '@eventId'
// }, {
// 	search: { method: 'post', isArray: false, url: EdgeApiConfig.path('scheduling/events/search'), params: { expand: '@expand' } },
// 	searchNearby: { method: 'get', isArray: false, url: EdgeApiConfig.path('schedules/nearbyevents'), params: { expand: '@expand' } },
// 	searchEvents: { method: 'get', isArray: false, url: EdgeApiConfig.path('schedules/events'), params: { expand: '@expand' } },
// 	timeOfDay: { method: 'get', isArray: true, url: EdgeApiConfig.path('scheduling/events/timeofday') },
// 	getResourceAvailability: { method: 'get', isArray: false, url: EdgeApiConfig.path('scheduling/availability'), params: { resources: '@resources', start: '@start', end: '@end' } },
// 	cancel: { method: 'post', isArray: false, url: EdgeApiConfig.path('scheduling/events/cancel'), params: { reservationId: '@reservationId', ssoId: '@ssoId', memberId: '@memberId' } }
// });

class EdgeApiClass extends AxiosServiceClass {
	endpointConfig = [
		{
			key: 'details-get',
			path: (eventId) => `edge/api/scheduling/events/${eventId}`,
			mock: 'context'
		},
		{
			key: 'resource-get',
			path: (resourceId) => `edge/api/resources/${resourceId}`,
			mock: 'context'
		},
		{
			key: 'nearby-get',
			path: () => 'edge/api/schedules/nearbyevents',
			mock: 'none'
		},
		{
			key: 'search-post',
			path: () => 'edge/api/scheduling/events/search',
			mock: 'none'
		},
		{
			key: 'addToCalendar-get',
			path: (params) => 'edge/api/scheduling/addtocalendar?' + Helpers.objectToQueryString(params),
			mock: 'none'
		}
	];

	addToCalendar(params) {
		return this.endpoint('addToCalendar-get', params);
	}

	getEvent(eventId) {
		return this.get(
			this.endpoint('details-get', eventId),
			this.getConfig()
		);
	}

	getResource(resourceId) {
		return this.get(
			this.endpoint('resource-get', resourceId),
			this.getConfig()
		);
	}

	searchNearbyByEventId(upcCode, eventId) {
		const start = momentProvider().startOf('day');
		const end = momentProvider().add(import.meta.env.VITE_MAX_DAYS_EVENTS_FORWARD, 'days').endOf('day');
		const latLng = FrameworkService.data('club.latitude') + ',' + FrameworkService.data('club.longitude');
		const request = {
			'clubId': 0,
			'eventId': eventId,
			'includeAllProducts': true,
			'upc': upcCode,
			'start': start.format(),
			'end': end.format(),
			'status': 'confirmed',
			'pagenumber': 1,
			'pagesize': 3,
			'distance': 50,
			'latLng': latLng
		};
		return this.get(
			this.endpoint('nearby-get'),
			this.getConfig(request)
		);
	}

	searchNearbyByClubId() {
		const start = momentProvider().startOf('day');
		const end = momentProvider().add(import.meta.env.VITE_MAX_DAYS_EVENTS_FORWARD, 'days').endOf('day');
		const latLng = FrameworkService.data('club.latitude') + ',' + FrameworkService.data('club.longitude');
		const request = {
			'tags': [
				'featured:Event'
			],
			'clubId': StateService.getClubId(),
			'start': start.format(),
			'end': end.format(),
			'status': 'confirmed',
			'pagenumber': 1,
			'pagesize': 3,
			'facet': 'tags:interestFormat,tags:age,location.name',
			'distance': 50,
			'latLng': latLng
		};

		return this.get(
			this.endpoint('nearby-get'),
			this.getConfig(request)
		);
	}

	// TODO: @Drew this how the class schedule search in called currently in the Edge Api
	searchClasses(startDate, days, isBioMode, selectedFilters) {
		return this.post(
			this.endpoint('search-post'),
			buildClassSearchRequest(startDate, days, isBioMode, selectedFilters),
			this.getConfig()
		);
	}

	search(body) {
		return this.post(
			this.endpoint('search-post'),
			body,
			this.getConfig()
		);
	}
}

function getTimeModel(date, hour, minute, second, millisecond) {
	var dateTime = date.add(hour, 'h').add(minute, 'm').add(second, 's').add(millisecond, 'ms');
	return {
		'date': dateTime.clone().startOf('day').format('YYYY-MM-DD'),
		'dateTime': dateTime.clone().format(),
		'timezone': null
	};
}

function buildClassSearchRequest(startDate, days, isBioMode, selectedFilters) {
	days = days || 7;

	// @Drew: these are the body parameters passed in the POST request to Edge Api for the class schedule search
	// Not sure how much of this we will carry forward
	var request = {
		'pagenumber': 1,
		'pagesize': 750,
		'sortby': 'start.datetime',
		'sortdirection': 'Asc',
		'facet': 'organizers.name.displayname,tags:departmentDescription,tags:interest,tags:age,tags:intensity,tags:skillLevel,location.name,tags:timeOfDay',
		'tags': [
			'format:Class'
		],
		'start': getTimeModel(startDate.clone().startOf('day'), 0, 0, 0, 0).date,
		'end': getTimeModel(startDate.clone().startOf('day').add(days, 'days'), 0, 0, 0, 0).date,
		'isFree': false
	};

	// If in "bio mode", grab instructor name and location(s) from bio window object and add it to request
	if (isBioMode && (window.bio !== null && typeof window.bio !== 'undefined')) {
		request.organizers = [];
		request.locations = [];
		var name = '';
		// Construct the instructor name based on available bio attributes
		if (window.bio.nickName && window.bio.nickName.length > 0) {
			// Use the nickname value from workday
			name = window.bio.nickName;
		} else if ((window.bio.preferredFirstName && window.bio.preferredFirstName.length > 0) &&
			(window.bio.preferredLastName && window.bio.preferredLastName.length > 0)) {
			name = window.bio.preferredFirstName + ' ' + window.bio.preferredLastName.charAt(0) + '.';
		} else {
			name = window.bio.firstName + ' ' + window.bio.lastNameInitial + '.';
		}
		// Add instructor name to request
		request.organizers.push(name);
		// Add locations
		if (window.bio.clubs && window.bio.clubs.length > 0) {
			_.forEach(window.bio.clubs, function(club) {
				request.locations.push(club.name);
			});
		}
	} else {
		if (selectedFilters) {
			if (selectedFilters.timeOfDay && selectedFilters.timeOfDay.items) {
				selectedFilters.timeOfDay.items.forEach(function(item) {
					request.tags.push('timeOfDay:' + item.value);
				});
			}

			if (selectedFilters.instructor && selectedFilters.instructor.items) {
				request.organizers = [];
				selectedFilters.instructor.items.forEach(function(instructor) {
					request.organizers.push(instructor.name);
				});
			}

			if (selectedFilters.departmentDescription && selectedFilters.departmentDescription.items) {
				selectedFilters.departmentDescription.items.forEach(function(departmentDescription) {
					request.tags.push('departmentDescription:' + departmentDescription.value);
				});
			}

			if (selectedFilters.interest && selectedFilters.interest.items) {
				selectedFilters.interest.items.forEach(function(interest) {
					request.tags.push('interest:' + interest.value);
				});
			}

			if (selectedFilters.age && selectedFilters.age.items) {
				selectedFilters.age.items.forEach(function(age) {
					request.tags.push('age:' + age.value);
				});
			}

			if (selectedFilters.intensity && selectedFilters.intensity.items) {
				selectedFilters.intensity.items.forEach(function(intensity) {
					request.tags.push('intensity:' + intensity.value);
				});
			}

			if (selectedFilters.skillLevel && selectedFilters.skillLevel.items) {
				selectedFilters.skillLevel.items.forEach(function(skillLevel) {
					request.tags.push('skillLevel:' + skillLevel.value);
				});
			}

			if (selectedFilters.resource && selectedFilters.resource.items) {
				selectedFilters.resource.items.forEach(function(resource) {
					request.tags.push('resource:' + resource.value);
				});
			}

			if (selectedFilters.location && selectedFilters.location.items) {
				if (!request.locations) {
					request.locations = [];
				}

				selectedFilters.location.items.forEach(function(location) {
					request.locations.push(location.value);
				});
			}

			if (selectedFilters.showOnlyFree && selectedFilters.showOnlyFree.items) {
				request.isFree = true;
			}
		}
	}

	return request;
}

export const EdgeApi = new EdgeApiClass();
